import React from "react";
import { LucideIcon } from "lucide-react";

interface SidebarOptionProps {
  Icon: LucideIcon;
  name: string;
  number: number;
  active: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

function SidebarOption({
  Icon,
  name,
  number,
  active,
  onClick,
}: SidebarOptionProps) {
  return (
    <div
      className={`
                flex items-center justify-between px-4 py-2.5 mx-1 my-0.5 rounded-lg cursor-pointer transition-all duration-200
                ${
                  active
                    ? "bg-white text-brand font-medium shadow-sm"
                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900 font-normal"
                }
            `}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <Icon className="w-5 h-5" />
        <span className="text-sm">{name}</span>
      </div>
      {active && number > 0 && (
        <span className="bg-brand text-white text-xs font-medium px-2 py-0.5 rounded-full min-w-[1.25rem] text-center">
          {number}
        </span>
      )}
    </div>
  );
}

export default SidebarOption;
